module.exports = __webpack_public_path__ + "img/galery3.1c1cf96b.jpg";